import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core'
import { Link, useHistory } from 'react-router-dom'

import OutsideClickHandler from 'react-outside-click-handler'
import { SearchIcon, ClearIcon, RestoreIcon, ClearSmallIcon } from './Icons'
import Spinner from '../assets/images/spinner.gif'

const RECENT_SEARCH_VARIABLE = 'recentSearch'
const useStyles = makeStyles({
  searchBoxCommon: {
    width: '100%',
    position: 'relative',
  },
  sbcHead: {
    height: 40,
    background: '#F4F5F7',
    borderRadius: 3,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
  },
  whiteBackground: {
    background: 'rgba(255, 255, 255, 1)',
  },
  greyBackground: {
    background: 'transparent',
  },
  SearchIcon: {
    width: 36,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-end',
    paddingRight: 8,
  },
  inputSearch: {
    width: 'calc(100% - 36px)',
    height: '100%',
    border: 'none',
    outline: 'none',
    paddingRight: 32,
    boxSizing: 'border-box',
    '&::placeholder': {
      fontSize: 14,
      lineHeight: '22px',
      fontWeight: 400,
      color: '#757575',
    },
  },
  sbcContent: {
    background: 'white',
    padding: '14px 12px',
    boxSizing: 'border-box',
    position: 'absolute',
    top: 44,
    left: 0,
    width: '100%',
    border: '1px solid #DFE4EB',
    boxShadow: '0px 2px 10px rgba(223, 228, 235, 0.5)',
    borderRadius: 3,
    zIndex: 2,
  },
  sbcContentNoZero: {
    padding: 8,
  },
  ClearIcon: {
    position: 'absolute',
    right: 12,
    top: 12,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  sbcNoResult: {
    fontSize: 12,
    lineHeight: '14px',
    fontWeight: 400,
    color: '#8C8C8C',
  },
  sbcHeadActive: {
    border: '1px solid #496182',
  },
  sbcSearchContent: {
    maxHeight: 300,
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: 4,
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#DFE4EB',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: 'transparent',
    },
  },
  sbcSearchItem: {
    boxSizing: 'border-box',
    padding: 4,
    color: '#474747',
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 400,
    cursor: 'pointer',
    overflow: 'hidden',
    display: '-webkit-box',
    lineClamp: 2,
    boxOrient: 'vertical',
    '&:hover': {
      background: 'rgba(27, 57, 99, 0.1)',
      borderRadius: 3,
    },
  },
  sbcSearchItemHint: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  RestoreIcon: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  ClearSmallIcon: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  sbcSearchItemHintLeft: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    '& div:nth-child(2)': {
      marginLeft: 8,
      overflow: 'hidden',
      display: '-webkit-box',
      lineClamp: 2,
      boxOrient: 'vertical',
      width: '100%',
    },
  },
  sbcSuggestBlock: {
    marginBottom: 17,
  },
  sbcTitleBlock: {
    fontSize: 12,
    lineHeight: '14px',
    fontWeight: 600,
    color: '#474747',
    marginBottom: 9,
  },
  SpinnerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      width: 20,
    },
  },
})

interface SearchBoxCommonProps {
  placeholder?: string
  searchList?: any
  insidePage?: any
}

const SearchBoxCommon = ({
  placeholder,
  searchList,
  insidePage,
}: SearchBoxCommonProps) => {
  const classes = useStyles()
  const [focus, setFocus] = useState(false)
  const [toggleClose, setToggleClose] = useState(true)
  const [inputValue, setInputValue] = useState('')
  const [breakStep, setBreakStep] = useState(1)
  const [recent, setRecent] = useState<any>([])
  const [dymamicSearchList, setDynamicSearchList] = useState(searchList)
  const history = useHistory()
  let timeout: any = null

  useEffect(() => {
    setDynamicSearchList(searchList)
  }, [searchList])

  useEffect(() => {
    history.listen((location, action) => {
      setInputValue('')
    })

    if (localStorage.getItem(RECENT_SEARCH_VARIABLE)) {
      let recentSearch: any = localStorage.getItem(RECENT_SEARCH_VARIABLE)
      setRecent(JSON.parse(recentSearch))
    }
    return () => {
      window.clearTimeout(timeout)
    }
  }, [])

  const onFocusInput = () => {
    if (localStorage.getItem(RECENT_SEARCH_VARIABLE)) {
      let recentSearch: any = localStorage.getItem(RECENT_SEARCH_VARIABLE)
      setRecent(JSON.parse(recentSearch))
    }
    setFocus(true)
    setToggleClose(true)
  }

  const onHandleChangeInput = (event: any) =>
    getSearchResultByString(event.target.value)

  const getSearchResultByString = (str: string) => {
    setInputValue(str)
    const cloned = JSON.parse(JSON.stringify(searchList))
    const filteredList = cloned.filter(
      (item: any) =>
        item.searchTerm.toLowerCase().indexOf(str.toLowerCase()) !== -1,
    )
    setDynamicSearchList(filteredList)

    let recentSearch: any = localStorage.getItem(RECENT_SEARCH_VARIABLE)
    const clonedRecent =
      JSON.parse(JSON.stringify(JSON.parse(recentSearch))) === null
        ? []
        : JSON.parse(JSON.stringify(JSON.parse(recentSearch)))
    const filteredRecentList = clonedRecent.filter(
      (item: any) =>
        item.searchTerm.toLowerCase().indexOf(str.toLowerCase()) !== -1,
    )
    setRecent(filteredRecentList)
  }

  const onHandleClearInput = () => {
    setInputValue('')
    getSearchResultByString('')
    setToggleClose(false)
  }

  const onHandleClickItem = (val: any) => {
    setFocus(false)
    setInputValue(val.proper_name)
    history.push(`/company/${val.ticker}`)
    let recentSearch: any = localStorage.getItem(RECENT_SEARCH_VARIABLE)
    if (recentSearch !== null) {
      const existedLocalList = JSON.parse(recentSearch)
      const isItemExistedInLocal =
        existedLocalList.filter(
          (item: any) => item.proper_name === val.proper_name,
        ).length !== 0
      if (!isItemExistedInLocal) {
        localStorage.setItem(
          RECENT_SEARCH_VARIABLE,
          JSON.stringify(
            [
              {
                ...val,
                recent: true,
              },
              ...recent,
            ].slice(0, 4),
          ),
        )
      }
    } else {
      localStorage.setItem(
        RECENT_SEARCH_VARIABLE,
        JSON.stringify([
          {
            ...val,
            recent: true,
          },
        ]),
      )
    }
  }

  const onClearItemFromLocal = (e: any, option: any) => {
    e.stopPropagation()
    setRecent(recent.filter((i: any) => i.ticker !== option.ticker))
    localStorage.setItem(
      'recentSearch',
      JSON.stringify(recent.filter((i: any) => i.ticker !== option.ticker)),
    )
  }

  const handleScrollContent = (evt: any) => {
    if (
      evt.target.scrollHeight - evt.target.scrollTop >=
      evt.target.clientHeight
    ) {
      window.clearTimeout(timeout)
      timeout = setTimeout(() => {
        setBreakStep(prev => prev + 1)
      }, 200)
    }
  }

  return (
    <OutsideClickHandler
      onOutsideClick={() => {
        setFocus(false)
      }}
    >
      <div className={classes.searchBoxCommon}>
        <div
          className={`${classes.sbcHead} ${
            inputValue !== '' ? classes.sbcHeadActive : ''
          }`}
        >
          <div
            className={
              insidePage === 'portfolio'
                ? `${classes.SearchIcon} ${classes.whiteBackground}`
                : `${classes.SearchIcon} ${classes.greyBackground}`
            }
          >
            <SearchIcon />
          </div>
          {inputValue.length !== 0 && (
            <div onClick={onHandleClearInput} className={classes.ClearIcon}>
              <ClearIcon />
            </div>
          )}
          <input
            type="text"
            value={inputValue}
            onFocus={onFocusInput}
            onChange={onHandleChangeInput}
            className={
              insidePage === 'portfolio'
                ? `${classes.inputSearch} ${classes.whiteBackground}`
                : `${classes.inputSearch} ${classes.greyBackground}`
            }
            placeholder={placeholder}
          />
        </div>
        {toggleClose && (
          <>
            {focus && (
              <>
                {true && (
                  <div className={`${classes.sbcContent}`}>
                    <div
                      onScroll={handleScrollContent}
                      className={classes.sbcSearchContent}
                    >
                      {recent.length !== 0 && (
                        <div className={classes.sbcSuggestBlock}>
                          <div className={classes.sbcTitleBlock}>
                            Recent Search:
                          </div>
                          {recent.map((item: any) => (
                            <div
                              className={`${classes.sbcSearchItemHint} ${classes.sbcSearchItem}`}
                              key={item?.ticker}
                            >
                              <Link to={`/company/${item.ticker}`}>
                                <div
                                  onClick={() => onHandleClickItem(item)}
                                  className={classes.sbcSearchItemHintLeft}
                                >
                                  <div className={classes.RestoreIcon}>
                                    <RestoreIcon />
                                  </div>
                                  <div>{item.proper_name}</div>
                                </div>
                              </Link>
                              <div
                                onClick={(e: any) =>
                                  onClearItemFromLocal(e, item)
                                }
                                className={classes.ClearSmallIcon}
                              >
                                <ClearSmallIcon />
                              </div>
                            </div>
                          ))}
                        </div>
                      )}

                      {dymamicSearchList.length !== 0 && (
                        <div>
                          <div className={classes.sbcTitleBlock}>
                            Suggestions:
                          </div>
                          {dymamicSearchList
                            .slice(0, 20 + 15 * (breakStep - 1))
                            .map((item: any, index: any) => (
                              <Link
                                to={`/company/${item.ticker}`}
                                key={item?.ticker}
                              >
                                <div
                                  onClick={() => onHandleClickItem(item)}
                                  key={index}
                                  className={classes.sbcSearchItem}
                                >
                                  {item.proper_name}
                                </div>
                              </Link>
                            ))}
                        </div>
                      )}

                      {5 * breakStep < dymamicSearchList?.length && (
                        <div className={classes.SpinnerContainer}>
                          <img alt="spinner" src={Spinner} />
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {recent.length === 0 && dymamicSearchList.length === 0 && (
                  <div className={`${classes.sbcContent}`}>
                    <div className={classes.sbcNoResult}>
                      No result found. Please try different keyword.
                    </div>
                  </div>
                )}
              </>
            )}
          </>
        )}
      </div>
    </OutsideClickHandler>
  )
}

SearchBoxCommon.defaultProps = {
  placeholder: 'Search for company',
  searchList: [
    {
      id: 0,
      value:
        'Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 Test1 ',
    },
    { id: 1, value: 'Test2' },
    { id: 2, value: 'Test3' },
    { id: 3, value: 'Test4' },
    { id: 4, value: 'Test5' },
    { id: 5, value: 'Test6' },
    { id: 6, value: 'Test7' },
    { id: 7, value: 'Test8' },
    { id: 8, value: 'Test9' },
  ],
}

export default SearchBoxCommon
